/**
 * 
 * Select Field
 * 
 */

import React from 'react'
import PropTypes from 'prop-types'
import { ReactSearchAutocomplete } from "react-search-autocomplete"
import { Label, FormGroup } from 'reactstrap'

function SelectField(props) {
    const { label, name, onChange, isInvalid, metaData, options = [], required, labelClass, fuseOptions, customLabel, placeholder } = props
    const selectOptions = options && Array.isArray(options) ? options : typeof options === 'string' && metaData && metaData[options] && metaData[options].length > 0 ? metaData[options] : []

    return (
        <React.Fragment>
            <FormGroup className='no-margin'>
                {customLabel ? React.createElement(customLabel, props) : <Label className={labelClass} htmlFor={name}>{label} {required ? <span style={{ color: 'red' }}>*</span> : null}</Label>}
                <ReactSearchAutocomplete
                    name={name}
                    items={selectOptions}
                    fuseOptions={fuseOptions} // Search on both fields
                    resultStringKeyName="label" // String to display in the results
                    onSelect={(e) => onChange({ value: e.value})}
                    showIcon={false}
                    className={isInvalid ? "select2-error" : null}
                    invalid={isInvalid ? true : false}
                    placeholder={placeholder}
                    styling={{
                        height: "34px",
                        border: "1px solid #ced4da",
                        borderRadius: "4px",
                        backgroundColor: "white",
                        boxShadow: "none",
                        hoverBackgroundColor: "#E40D8C",
                        color: "black",
                        fontSize: "12px",
                        fontFamily: "Courier",
                        iconColor: "green",
                        clearIconMargin: "3px 8px 0 0",
                        zIndex: 2,
                    }}
                />
            </FormGroup>
        </React.Fragment>
    )

}

SelectField.propTypes = {
    t: PropTypes.any,
    label: PropTypes.string,
    value: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    isInvalid: PropTypes.any,
    metaData: PropTypes.object,
    options: PropTypes.any,
    required: PropTypes.any,
    labelClass: PropTypes.any,
    fuseOptions: PropTypes.any,
    customLabel: PropTypes.any
}

export default SelectField